import exame from '@/repositories/conecta-sus/parametrizacao/exameRepository'
import kitExame from '@/repositories/conecta-sus/parametrizacao/kitExameRepository'
import procedimento from '@/repositories/conecta-sus/parametrizacao/procedimentoRepository'
import procedimentoCirurgico from '@/repositories/conecta-sus/parametrizacao/procedimentoCirurgicoRepository'
import tabelaCid from '@/repositories/conecta-sus/parametrizacao/tabelaCidRepository'
import relatorioExameCadastrado from '@/repositories/conecta-sus/parametrizacao/relatorioExameCadastradoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        exame: exame(baseUrl),
        kitExame: kitExame(baseUrl),
        procedimento: procedimento(baseUrl),
        procedimentoCirurgico: procedimentoCirurgico(baseUrl),
        tabelaCid: tabelaCid(baseUrl),
        relatorioExameCadastrado: relatorioExameCadastrado(baseUrl),
    }
}
